import moment from "moment-timezone";

export const makeDateFromString = (string:string) => moment(string, 'YYYY-MM-DD HH:mm:ss').toDate();
export const makeUtcStringFromDate = (date:Date) => moment(date).utc().format('YYYY-MM-DD HH:mm:ss');
export const convertUtcTimeToLocalTime = (utcTime: string) => moment.utc(utcTime, 'HH:mm:ss').local().format('hh:mm A');
export const nowFormat = (date?:Date, format='YYMMDDHHmm') => moment(date).format(format);

const tzOffset = new Date().getTimezoneOffset()/-60;
export const timeZone = 'UTC' + (tzOffset >= 0 ? '+' : '') + (tzOffset);